const headNeck=
[
{symptom:"hoarse",
displayAs:"Unexplained hoarseness",
questionGroup: "hoarse"
},

{symptom:"neckLump",
displayAs:"Unexplained neck lump",
questionGroup: "neckNodes"
},

{symptom:"oralUlcer",
displayAs:"Oral ulcer for >3 weeks",
questionGroup: "mouthMass"
},

{symptom:"oralLump",
displayAs:"Lip or oral lump",
questionGroup: "mouthMass"
},

{symptom:"OralRedPatch",
displayAs:"Red or red/white oral patch (poss erythroleukoplakia)",
questionGroup: "leukoplakia"
},

{symptom:"thyroid",
displayAs:"Thyroid lump",
questionGroup: "thyroid",
},

{symptom: "headache",
displayAs: "Headache",
questionGroup: "headache",
},

{symptom:"cns",
displayAs:"CNS dysfunction",
questionGroup: "cns",
},

{
symptom: "squint",
displayAs: "Squint (children)",
questionGroup: "squint",
},

{symptom: "lossRedReflex",
displayAs: "Loss of red reflex (children)",
questionGroup: "redReflex",
},



]
export default headNeck